var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGppBadFill1Wght400Grad0Opsz48 = function SvgGppBadFill1Wght400Grad0Opsz48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m479 609 70 71q10 10 23.5 10t23.5-10 10-23-10-23l-69-69 69-69q9-9 9-22.5t-9-22.5-22-9-22 9l-70 70-71-70q-10-10-23.5-10T364 451t-10 23 10 23l70 69-70 70q-9 9-9 22t9 22 22 9 22-9zm1 364q-4 0-7.5-.5T466 971q-134-40-220-164.5T160 533V337q0-19 11-34.5t28-22.5l260-97q11-4 21-4t21 4l260 97q17 7 28 22.5t11 34.5v196q0 149-86 273.5T494 971z"
  })));
};
export default SvgGppBadFill1Wght400Grad0Opsz48;